// src/jsMain/kotlin/com/loyola/acessoescola/services/QuickAuthClient.Js.kt
@file:Suppress("UnsafeCastFromDynamic")


package com.loyola.acessoescola.services

import auth.AccountInfo
import auth.PublicClientApplication
import com.loyola.acessoescola.services.quintadb.ErrorMessages
import kotlinx.coroutines.await
import kotlin.js.json

actual class PresentationContext

class JSQuickAuthClient: QuickAuthClient {

    private val msal = PublicClientApplication(js("{\n" +
            "    auth: {\n" +
            "        clientId:  '2c269cc4-968a-4985-b7cc-6f865f633feb',\n" +
            "        authority: 'https://login.microsoftonline.com/f92e0574-d951-4dc0-8d36-50fefaa1fc95/v2.0',\n" +
            "        redirectUri: '/blank.html',\n" +
            "        navigateToLoginRequestUrl: true,\n" +
            "    }}"))

    override suspend fun initialize() {
        msal.initialize().await()
    }

    override suspend fun sign(onSuccessCallBack: () -> Unit, onErrorCallBack: (String?) -> Unit) {
        val loginRequest = json("scopes" to arrayOf("User.Read"))

        val result = msal.loginPopup(loginRequest).await()
        if (result != null) {
            msal.setActiveAccount(result.account)
            onSuccessCallBack()
        } else {
            onErrorCallBack(ErrorMessages.UNKNOWN.message)
        }

    }

    override fun getCurrentAccount(
        onErrorCallBack: (String?) -> Unit,
        onSuccessCallBack: (String?, String?) -> Unit
    ) {
        val account: AccountInfo? = msal.getActiveAccount()
        if (account != null) {
            onSuccessCallBack(account.username, account.idToken)
        } else {
            onErrorCallBack(ErrorMessages.UNKNOWN.message)
        }
    }

    override fun singout(onSuccessCallBack: () -> Unit, onErrorCallBack: (String?) -> Unit) {
        msal.logoutPopup()
        onSuccessCallBack()
    }
}

actual fun getQuickAuthClient(context: PresentationContext): QuickAuthClient = JSQuickAuthClient()